<template>
  <v-container v-if="items.length" class="py-10 py-md-13 py-lg-16">
    <TitleWidget>{{ title }}</TitleWidget>

    <CarouselWidget
      class="mt-10"
      :items="items"
      v-bind="carouselSettings"
      :gap="gap"
    >
      <template #item="{ item }">
        <ClientCard v-bind="item" />
      </template>
    </CarouselWidget>
  </v-container>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import ClientCard from "../cards/ClientCard.vue";

const _config = {
  mod: "clients",
};

const _carouselSettings = {
  itemsToShow: {
    xs: 2.5,
    sm: 5,
    md: 5,
    lg: 6,
    xl: 6,
  },
};

const _data = {
  title: "Clientes",
  carouselSettings: _carouselSettings,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    gap() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
          return 60;
        case "md":
          return 50;
        default:
          return 30;
      }
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
    CarouselWidget,
    ClientCard,
  },
};
</script>
